export default "<h1>{{title}}</h1>\n<app-password></app-password>"